import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { credits } from '../../data/home';
import { ArrowButton } from '../ui/ArrowButton';
export function Credits() {
  return <section className="w-full bg-canvas py-24" data-id="element-41" data-mp="2rukdqv5vmqbj">
      <div className="mx-auto grid max-w-[1320px] gap-14 px-6 lg:grid-cols-12" data-id="element-42" data-mp="2muplooad7uow">
        <div className="lg:col-span-4" data-id="element-43" data-mp="2mwso67spfgai">
          <h2 className="font-display text-[52px] text-ink md:text-[64px]" data-id="element-44" data-mp="30tz0bjixagqr">
            Financer
            <br data-id="element-45" data-mp="2vvxmbd0ct7m5" />
            ce qui compte
          </h2>
          <p className="mt-5 max-w-sm text-[16px] leading-relaxed text-ink-muted" data-id="element-46" data-mp="2vtbc15m2we08">
            Des crédits clairs, adaptés à vos revenus, avec un conseiller qui vous suit de la demande au dernier
            remboursement.
          </p>
          <ArrowButton to="/particuliers/credits" className="mt-8" data-id="element-47" data-mp="3jkgrvks0r6aj">
            Tous nos crédits
          </ArrowButton>
        </div>

        <ul className="border-t border-ink/10 lg:col-span-8" data-id="element-48" data-mp="3fkojp96jf25p">
          {credits.map(c => <li key={c.name} className="border-b border-ink/10" data-id="element-49" data-mp="1a1wq5ckpj863">
              <Link to={c.path} className="group grid items-center gap-3 py-7 md:grid-cols-12 md:gap-8" data-id="element-50" data-mp="1e1nd1574545c">
                <span className="font-display text-[32px] text-ink transition-colors group-hover:text-brand md:col-span-5 md:text-[40px]" data-id="element-51" data-mp="1j10ccpf683ot">
                  {c.name}
                </span>
                <span className="text-[15px] leading-relaxed text-ink-muted md:col-span-6" data-id="element-52" data-mp="1szzb9ga4wkym">{c.text}</span>
                <span className="hidden justify-end md:col-span-1 md:flex" data-id="element-53" data-mp="1x0j4w9vi16g0">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-ink/15 transition-colors group-hover:border-ink group-hover:bg-ink group-hover:text-leaf" data-id="element-54" data-mp="21rrg9bge31vt">
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="2bpxjbwdxme29" />
                  </span>
                </span>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}